import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const UnaprovedStudentList = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        sectionMasterId: sectionMasterId,
        instituteMasterId: instituteMasterId,
        year: '',
        gradeId: '',
        divisionId: '',
    }

    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [importStudentData, setImportStudentData] = useState(initialFormState)
    const [aprovedStudentData, setAproveStudentData] = useState([])
    const [importStudentList, setImportStudentList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [studentIdSort, setStudentIdSort] = useState(null);
    const [regIdSort, setRegIdSort] = useState(null);
    const [nameSort, setNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["std_id", "regis_no", "studentName", "primaryContact", "email"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGradeList()
        getYearList()
    }, []);

    useEffect(() => {
        getImportStudentList();
    }, [importStudentData]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getImportStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (importStudentData.year !== '') {
                setImportStudentList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim(), "rows"))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(importStudentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(importStudentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > importStudentList.length) {
            endIndex = importStudentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(importStudentList.slice(startIndex, endIndex));
    }, [importStudentList, currPage, itemsPerPage]);

    const getImportStudentList = async () => {
        if (importStudentData.year !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl());
                setImportStudentList(response.data.result.rows);
            } catch (error) {
                setImportStudentList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getApiUrl = () => {
        let apiUrl = '/not-approved-students?';
        if (importStudentData.sectionMasterId !== '') {
            apiUrl += `sectionMasterId=${importStudentData.sectionMasterId}&`;
        }
        if (importStudentData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${importStudentData.instituteMasterId}&`;
        }
        if (importStudentData.year !== '') {
            apiUrl += `year=${importStudentData.year}&`;
        }
        if (importStudentData.gradeId !== '') {
            apiUrl += `gradeId=${importStudentData.gradeId}&`;
        }
        if (importStudentData.divisionId !== '') {
            apiUrl += `divisionId=${importStudentData.divisionId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleGradeChange = (e) => {
        setImportStudentData((prevData) => {
            return {
                ...prevData,
                divisionId: '',
                [e.target.name]: e.target.value
            }
        })
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const Approve = async () => {
        if (aprovedStudentData.length !== 0) {
            setLoading(true);
            const data = {
                sectionMasterId,
                instituteMasterId,
                students: aprovedStudentData,
            };

            const apiUrl = `/approve-students`;

            try {
                const response = await authorizedAxiosSection.post(apiUrl, data);

                await getImportStudentList();
                setAproveStudentData([]);

                setStudentIdSort(null);
                setRegIdSort(null);
                setNameSort(null);

                setTimeout(() => {
                    Swal.fire({ text: response.data.message });
                }, 100);

            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false); // End loading
            }
        } else {
            Swal.fire("Please Select Student");
        }
    };

    useEffect(() => {
        if (studentIdSort == true || studentIdSort == false) {
            setRegIdSort(null);
            setNameSort(null);
        }
    }, [studentIdSort])

    useEffect(() => {
        if (regIdSort == true || regIdSort == false) {
            setStudentIdSort(null);
            setNameSort(null);
        }
    }, [regIdSort])

    useEffect(() => {
        if (nameSort == true || nameSort == false) {
            setStudentIdSort(null);
            setRegIdSort(null);
        }
    }, [nameSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Non Approve Student</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-user-minus"></i> Non Approved Student</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='year' onChange={handleInputChange} value={importStudentData.year}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeId' onChange={handleGradeChange} value={importStudentData.gradeId}>
                                                        <option selected value={''} disabled>Select Class :</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='divisionId' onChange={handleInputChange} value={importStudentData.divisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <button className='btn btn-success approve_icon' style={{ margin: "20px" }} onClick={() => Approve()}>Approve</button>
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: "20px" }}></th>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Std Id
                                                                            <SortIcon sortState={studentIdSort} setSortState={setStudentIdSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"std_id"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Reg Id
                                                                            <SortIcon sortState={regIdSort} setSortState={setRegIdSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"regis_no"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Name
                                                                            <SortIcon sortState={nameSort} setSortState={setNameSort} setData={setImportStudentList} setCurrPage={setCurrPage} sortingPath={"studentName"} />
                                                                        </th>
                                                                        <th scope="col">Phone No</th>
                                                                        <th scope="col">Email</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th>{std.isApproved || <input type='checkbox' checked={aprovedStudentData.includes(std.id)} onClick={() => { aprovedStudentData.includes(std.id) ? setAproveStudentData(aprovedStudentData.filter(i => i !== std.id)) : setAproveStudentData(pre => [...pre, std.id]) }} />}</th>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std.std_id}</td>
                                                                                        <td>{std.regis_no}</td>
                                                                                        <td>{std.studentName}</td>
                                                                                        <td>{std.primaryContact}</td>
                                                                                        <td>{std.email}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={importStudentList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UnaprovedStudentList;